import {useState, useEffect} from 'react';
import {
  HMSNotificationTypes,
  useHMSActions,
  useHMSNotifications,
} from '@100mslive/react-sdk';
import {RequestDialog} from './../primitives/DialogContent';
import {MicOnIcon, VideoOnIcon} from '@100mslive/react-icons';
import { decryptText } from '../../utils/CommonFunction';
import { capitalizeFirstLetter } from '../../utils/CommonUtils';

export const TrackUnmuteModal = () => {
  const hmsActions = useHMSActions();
  const notification = useHMSNotifications([
    HMSNotificationTypes.CHANGE_TRACK_STATE_REQUEST,
    HMSNotificationTypes.ROOM_ENDED,
    HMSNotificationTypes.REMOVED_FROM_ROOM,
  ]);
  const [muteNotification, setMuteNotification] = useState<any>(null);

  useEffect(() => {
    switch (notification?.type) {
      case HMSNotificationTypes.REMOVED_FROM_ROOM:
      case HMSNotificationTypes.ROOM_ENDED:
        setMuteNotification(null);
        break;
      case HMSNotificationTypes.CHANGE_TRACK_STATE_REQUEST:
        if (notification?.data.enabled) {
          setMuteNotification(notification.data);
        }
        break;
      default:
        return;
    }
  }, [notification]);

  if (!muteNotification) {
    return null;
  }

  const {requestedBy: peer, track, enabled}: any = muteNotification;

  return (
    <RequestDialog
      title={`${capitalizeFirstLetter(track?.type ?? "Track")} Unmute Request`} 
      onOpenChange={(value: any) => !value && setMuteNotification(null)}
      body={`${decryptText(peer?.name)} has requested you to unmute your ${track?.source} ${track?.type}.`}
      onAction={() => {
        hmsActions.setEnabledTrack(track.id, enabled);
        setMuteNotification(null);
      }}
      Icon={track?.type === 'video' ? VideoOnIcon : MicOnIcon}
    />
  );
};
